/**
 * Layer Strategy Registration
 *
 * This file imports and registers all layer strategies with the LayerStrategyFactory.
 * Import this file to ensure all strategies are available for use.
 */

import { LayerStrategyFactory } from './LayerStrategy';

// Import all strategy instances
import { songsLayerStrategy } from './SongsLayerStrategy';
import { starsLayerStrategy } from './StarsLayerStrategy';
import { looksLayerStrategy } from './LooksLayerStrategy';
import { movesLayerStrategy } from './MovesLayerStrategy';
import { worldsLayerStrategy } from './WorldsLayerStrategy';
import { brandedLayerStrategy } from './BrandedLayerStrategy';
import { personalizeLayerStrategy } from './PersonalizeLayerStrategy';
import { trainingDataLayerStrategy } from './TrainingDataLayerStrategy';
import { compositeLayerStrategy } from './CompositeLayerStrategy';
import { rightsLayerStrategy } from './RightsLayerStrategy';

/**
 * Register all layer strategies
 * This function must be called before using any strategies
 */
export function registerAllLayerStrategies(): void {
  console.log('🔧 [LAYER STRATEGIES] Registering all layer strategies...');

  try {
    // Register all strategies
    LayerStrategyFactory.registerStrategy('G', songsLayerStrategy);
    LayerStrategyFactory.registerStrategy('S', starsLayerStrategy);
    LayerStrategyFactory.registerStrategy('L', looksLayerStrategy);
    LayerStrategyFactory.registerStrategy('M', movesLayerStrategy);
    LayerStrategyFactory.registerStrategy('W', worldsLayerStrategy);
    LayerStrategyFactory.registerStrategy('B', brandedLayerStrategy);
    LayerStrategyFactory.registerStrategy('P', personalizeLayerStrategy);
    LayerStrategyFactory.registerStrategy('T', trainingDataLayerStrategy);
    LayerStrategyFactory.registerStrategy('C', compositeLayerStrategy);
    LayerStrategyFactory.registerStrategy('R', rightsLayerStrategy);

    console.log('✅ [LAYER STRATEGIES] All 10 layer strategies registered successfully');
  } catch (error) {
    console.error('🚨 [LAYER STRATEGIES] Failed to register strategies:', error);
    throw error;
  }
}

// Auto-register on import
registerAllLayerStrategies();

// Export factory for convenience
export { LayerStrategyFactory } from './LayerStrategy';